import { Header } from "./Header.";
import Footer from "./Footer";
import "./Styles/legal.css";
import React from "react";
import PageHeader from "./PageHeader";

export const Politique = () => {
    const titleStyle = {
        width: "100%",
        textAlign: "left",
        fontSize: "18px",
        height: "auto",
        color: "#C8437E",
        fontWeight: "bold",
    };

    const containerText = {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: "5px",
        height: "auto",
        textAlign: 'justify',
        lineHeight: '25px'
    };

    const textContainStyle = {
        width: "100%",
        textAlign: "left",
        height: "auto",
        fontSize: "16px",
        display: "13px",
        color: "black",
        wordBreak: "break-all", //ça arrange le texte mais ça coupe mal les mots, au pire commente la ligne...
    };

    document.title = "Politique de confidentialité - KabaaShop";

    const spacingTxt = (
        <>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </>
    );
    return (
        <>
            <Header />
            <PageHeader title={"Politique de confidentialité"} />
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "15px",
                    width: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    padding: "15px 10px",
                }}
                className='legal-container'
            >
                <span
                    style={{
                        width: "auto",
                        textAlign: "center",
                        boxSizing: "border-box",
                        fontSize: "18px",
                        padding: "10px 14px",
                        backgroundColor: "#C8437E",
                        fontWeight: "bolder",
                        color: "white",
                    }}
                >
                    Politique de confidentialité de la boutique KabaaShop
                </span>
                <span style={titleStyle}>GÉNÉRALITÉS</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}Nous souhaitons vous informer et vous permettre de contrôler ce qu'il advient de vos données personnelles. Vous
                        trouverez ci-dessous des informations sur les données que nous collectons, les raisons pour lesquelles nous le
                        faisons, la période pendant laquelle nous les conservons, vos droits en matière de vie privée et comment vous
                        pouvez les exercer.
                        Cette politique de confidentialité est susceptible d’être modifiée ou complétée à tout moment par KABAA
                        SHOP, notamment en vue de se conformer à toute évolution législative, règlementaire, jurisprudentielle ou
                        technologique. Dans un tel cas, la date de sa mise à jour sera clairement identifiée en tête de la présente
                        politique. Ces modifications engagent l’Utilisateur dès leur mise en ligne. Il convient par conséquent que
                        l’Utilisateur consulte régulièrement la présente politique de confidentialité et d’utilisation des cookies afin de
                        prendre connaissance de ses éventuelles modifications.
                    </span>
                </div>

                <span style={titleStyle}>I. DONNÉES PERSONNELLES</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}D’une manière générale, il vous est possible de visiter le Site www.kabaashop.com sans communiquer aucune
                        information personnelle vous concernant. En toute hypothèse, vous êtes en aucune manière obligé de transmettre
                        ces informations à KABAA SHOP.
                        Néanmoins, en cas de refus, il se peut que vous ne puissiez pas bénéficier de certaines informations ou services
                        que vous avez demandés. A ce titre en effet, KABAA SHOP peut être amenée dans certains cas à vous demander
                        de renseigner votre nom, prénom, adresse mail, numéro de téléphone, entreprise et fonction ou toutes autres
                        informations nécessaires à utilisation du site. En fournissant ces informations, vous acceptez expressément
                        qu’elles soient traitées par KABAA SHOP, pour les finalités indiquées au point 3 ci-dessous.
                        Conformément à la Loi sénégalaise n° 2008-12 du 25 janvier 2008 portant sur les Données à Caractère
                        Personnel, KABAA SHOP vous informe des points suivants :
                    </span>
                </div>

                <span style={titleStyle}>1. Les catégories de données à caractère personnel collectées</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}<ul><li>Données d'utilisateur: nous distinguons les données personnelles qui permettent de vous identifier en
                            tant qu'utilisateur de nos produits et services (par exemple, votre nom et vos documents d'identification
                            comme une copie du recto/verso de votre carte d'identité), les données personnelles qui nous permettent
                            de prendre contact avec vous (par exemple, votre adresse, votre adresse e-mail et votre numéro de
                            téléphone), les données personnelles qui indiquent vos caractéristiques personnelles (par exemple votre
                            âge, votre sexe….), vos habitudes de vie et de consommation (par exemple, la composition de votre
                            ménage)</li></ul>

                        Comme prévu par la loi, nous ne traitons pas de données sensibles, à savoir celles qui concernent notamment
                        votre origine raciale ou ethnique, vos opinions politiques, vos préférences sexuelles et votre santé.
                    </span>
                </div>

                <span style={titleStyle}>2. Identité du responsable du traitement</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}Le responsable du traitement est KABAA SHOP, ayant son siège social au Sicap Baobab Lot N° 977, Dakar.<br />
                        Tél. :.33 824 70 43 OU le 766230070
                    </span>
                </div>

                <span style={titleStyle}>3. Finalité du traitement</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}KABAA SHOP ne traite les données personnelles que pour des finalités déterminées et explicites. KABAA
                        SHOP ne traite pas ces données de manière incompatible avec ces finalités.
                        KABAA SHOP traite vos données dans le cadre de l’exécution d’un contrat.
                        A cet effet, les finalités poursuivies par KABAA SHOP sont les suivantes :
                        <ul>
                            <li>Gérer l'identité du client ou de l’utilisateur et l'authentifier</li>
                            <li>Gérer la commande</li>
                            <li>Gérer le matériel</li>
                            <li>Facturer et encaisser les paiements</li>
                            <li>Assurer le service avant-vente et vendre</li>
                            <li>Assurer le Service Après-Vente</li>
                            <li>Gérer les données personnelles, caractéristiques et droits d'un contrat</li>
                            <li>Traiter les réclamations</li>
                            <li>Communiquer au titre de la gestion de la clientèle</li>
                            <li>Gérer les courriers entrants</li>
                            <li>Recouvrer à l'amiable les impayés</li>
                            <li>Gérer les contentieux</li>
                            <li>Gérer les demandes relatives aux droits des personnes concernées</li>
                            <li>Stocker des données du client ou d'un utilisateur</li>
                        </ul>

                        Vos données sont conservées pour la durée nécessaire à l’accomplissement des finalités mentionnées ci-dessus.
                        S’agissant des traitements relatifs à l’exécution du contrat, les données peuvent être conservées au maximum
                        pour une durée de trois ans à compter de la fin de la relation.<br />
                        KABAA SHOP réalise également des traitements de données pour d’autres finalités que la stricte
                        exécution de contrats. Ces traitements pourront faire l’objet, autant que de besoin, du recueil de votre
                        consentement, que vous pourrez retirer à tout moment.
                        A cet effet, les finalités poursuivies par KABAA SHOP sont les suivantes :
                        <ul>
                            <li>Organiser des opérations de marketing direct.</li>
                            <li>Organiser des animations</li>
                            <li>Collecter des données personnelles faisant l'objet d'un consentement</li>
                            <li>Sonder les clients ou les utilisateurs</li>
                            <li>Améliorer notre offre et relation client</li>
                        </ul>
                        Vos données sont conservées pour la durée nécessaire à l’accomplissement des finalités mentionnées ci-dessus.
                        Vos données peuvent être conservées le temps nécessaire pour permettre à KABAA SHOP de répondre à ses
                        obligations légales.
                        KABAA SHOP est également susceptible de réaliser des traitements de vos données à des fins statistiques,
                        y compris en commercialisant les statistiques obtenues. Dans ce cas l’ensemble des données est
                        préalablement rendu anonyme.
                    </span>
                </div>

                <span style={titleStyle}>4. Prestataires habilités et transferts des données</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}Nous pouvons transférer vos données à caractère personnel à nos partenaires éventuels et aux entreprises
                        affiliées au sein du groupe KABAA SHOP aux mêmes fins que celles mentionnées dans la présente politique de
                        protection de la vie privée, par exemple pour vous informer des produits et services de l'ensemble du groupe
                        KABAA SHOP.Les données recueillies peuvent être communiquées à des sous-traitants et partenaire qui travaillent pour notre
                        compte et contribuent à la délivrance de nos produits et services. Dans ce cas, KABAA SHOP prend les
                        dispositions nécessaires avec ses sous-traitants et partenaires afin de garantir un niveau de protection de vos
                        données adéquates et ce en toute conformité avec la règlementation applicable.
                        En cas de transfert de données hors du Sénégal, nous nous assurons par des mesures contractuelles ou autres que
                        ces données y bénéficient d'un niveau de protection approprié, comparable à la protection dont elles
                        bénéficieraient au Sénégal conformément à la réglementation de la protection des données personnelles.
                        Par contre si KABAA SHOP fournit des données personnelles à des tiers dans d'autres situations, cela se fait
                        toujours avec une notification explicite, en donnant une explication sur le tiers, les fins de la communication et
                        du traitement ainsi que l’existence d’une politique de sécurité approprié. Si c'est requis par la loi, nous vous
                        demandons votre autorisation explicite.
                    </span>
                </div>

                <span style={titleStyle}>5. Nos mesures techniques et organisationnelles de protection</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}Nous prenons toutes les mesures techniques et organisationnelles pour protéger vos données à caractère
                        personnel et assurer leur confidentialité.
                        Pour la protection de vos données, on contrôle au préalable le respect de la législation et de la réglementation. En
                        outre, nous appliquons différentes mesures techniques pour protéger vos données personnelles contre l'accès et
                        l'utilisation illicites, la perte ou le vol, à savoir : la protection par mot de passe, logiciel de cryptage de disque
                        dur, pare-feu, antivirus, détection des intrusions et des anomalies et contrôles d’accès.
                    </span>
                </div>

                <span style={titleStyle}>6. Durée de conservation des données</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}Nous ne pouvons pas conserver vos données à caractère personnel au-delà du temps nécessaire à la réalisation de
                        l'objectif pour lequel nous les collectons. Le délai de conservation peut donc différer en fonction de la finalité. A
                        l'issue des délais de conservation applicables, les données à caractère personnel sont supprimées ou rendues
                        anonymes.
                    </span>
                </div>

                <span style={titleStyle}>7. Politique relative aux cookies</span>
                <div style={containerText}>
                    <span style={textContainStyle}>
                        {spacingTxt}Notre site internet utilise des cookies.
                        Les cookies sont de petits fichiers texte enregistrés sur votre disque dur, dont la plupart sont destinés à permettre
                        ou faciliter votre navigation et sont nécessaires au fonctionnement de notre site en ligne. Les cookies ne sont pas
                        nominatifs et permettent uniquement de connaître le nombre de clics de chaque Utilisateur. Les cookies externes
                        liés aux publicités permettent de conditionner les campagnes publicitaires pour éviter leur répétition excessive
                        sur le Site.
                        Les données collectées sont destinées à l’usage de nos services offerts. Elles sont nécessaires au traitement et à la
                        gestion de vos commandes ainsi qu’aux relations commerciales entre KABAA SHOP et vous. Elles permettent
                        également à KABAA SHOP de vous fournir des services personnalisés et d’améliorer la pertinence des
                        informations qui vous sont proposées.
                        Les navigateurs possèdent des fonctionnalités qui permettent à l’Internaute de s’opposer à l’enregistrement de
                        cookies, d’être prévenu avant d’accepter les cookies, ou de les effacer.
                        ATTENTION : Nous attirons votre attention sur le fait que le refus du dépôt de cookies sur votre terminal est
                        néanmoins susceptible d’altérer votre expérience d’utilisateur ainsi que votre accès à certains services ou
                        fonctionnalités du présent site web. Le cas échéant, KABAA SHOP décline toute responsabilité concernant les
                        conséquences liées à la dégradation de vos conditions de navigation qui interviennent en raison de votre choix de
                        refuser, supprimer ou bloquer les cookies nécessaires au fonctionnement du site. Ces conséquences ne sauraient
                        constituer un dommage et vous ne pourrez prétendre à aucune indemnité de ce fait.
                    </span>
                </div>

            </div>
            <Footer />
        </>
    );
};
